<script lang="ts">
  import { type Snippet } from 'svelte';

  import Loader from '$shared/atoms/Loader/Loader.svelte';
  import Screenshots from '$shared/molecules/Screenshots/Screenshots.svelte';
  import { EntityTab } from '../EntityViewProp';
  import List from './List.svelte';
  import type { CustomComponent } from '$shared/components/types';
  import EntityProcessLoader from '$shared/molecules/EntityProcessLoader/EntityProcessLoader.svelte';

  interface Props {
    name?: string;
    loading?: boolean;
    verifiedResults?: IDataList[];
    providedInfo: IDataList;
    additionalProvidedInfo?: IDataList[];
    customResult?: CustomComponent;
    activeTab?: string;
    screenshots?: Array<string>;
    hideTab?: boolean;
    hasVerification?: boolean;
    verificationProcessingLabel?: string | undefined;
    providedInfoMeta?: Snippet | undefined;
    children?: Snippet | undefined;
    onevent?: (payload: any) => void;
  }

  let {
    name = '',
    loading = false,
    verifiedResults = [],
    providedInfo,
    additionalProvidedInfo = [],
    customResult = null,
    activeTab = '',
    screenshots = [],
    hideTab = false,
    hasVerification = false,
    verificationProcessingLabel = undefined,
    providedInfoMeta = undefined,
    children = undefined,
    onevent
  }: Props = $props();

  const onScreenshotPreview = (url: string): void => {
    onevent?.({ type: 'preview', data: url });
  };
</script>

<div class="entity-container">
  {#if hideTab}
    <List name={`${name}-result`} dataList={[providedInfo, ...additionalProvidedInfo]} {onevent} />
  {:else if activeTab === EntityTab.Result}
    {@render children?.()}
    <div data-cy={`${name}-result`} class="result">
      {#if loading && hasVerification}
        <EntityProcessLoader label={verificationProcessingLabel} />
      {:else if loading}
        <div class="loader">
          <Loader count={3} />
        </div>
      {:else if customResult?.component}
        {@const SvelteComponent = customResult?.component}
        <SvelteComponent {...customResult?.props || {}} {onevent} />
      {:else}
        <List dataList={verifiedResults} {onevent} />
        {#if screenshots?.length > 0}
          <div class="screenshot">
            <Screenshots list={screenshots} onpreview={onScreenshotPreview} />
          </div>
        {/if}
      {/if}
    </div>
  {:else if activeTab === EntityTab.ProvidedInfo}
    {@render providedInfoMeta?.()}
    <List name={`${name}-result`} dataList={[providedInfo, ...additionalProvidedInfo]} {onevent} />
  {:else}
    <div class="empty">Invalid tab chosen</div>
  {/if}
</div>

<style>
  .empty {
    background-color: var(--grey-bg);
    line-height: 30px;
    padding: 0 8px;
    color: var(--grey-medium);
    font-style: italic;
  }
  .result {
    width: 100%;
    display: flex;
    overflow: hidden;
  }
  .result .loader {
    width: 100%;
  }
  .screenshot {
    flex-shrink: 0;
    width: 300px;
    padding-left: 16px;
  }
</style>
